<template>
    <div v-if="!this.$store.state.underConstructionActive ||
        (typeof getCookie('under-construction-validated') !== undefined &&
            getCookie('under-construction-validated') == 'yes')
        " id="global-wrapper" class="global-wrapper"
        :class="[currentRouteName, { 'not-logged-in': !isAuthenticated }, { 'contains-background': this.$store.state.getBodyBackgroundUrl }]">
        <metainfo></metainfo>
        <Header v-if="isAuthenticated" />
        <div class="body-bg" v-if="this.$store.state.getBodyBackgroundUrl && checkFullBodyBgPages()" :style="{
            backgroundImage:
                'url(' + this.$store.state.getBodyBackgroundUrl + ')'

        }"></div>
        <main>
            <router-view :key="$route.fullPath" />
        </main>
        <Footer />

    </div>
    <div class="global-under-construction-wrapper" v-else>
        <UnderConstruction />
    </div>
    <!-- <transition name="fade">
        <LoginPopup v-if="$store.state.displayLoginPopup" @forgotPasswordClicked="forgotPasswordPopup" />
    </transition> -->
    <transition name="fade">
        <ForgotPasswordPopup @showLoginPopupAgain="loginPopup" v-if="$store.state.displayPasswordPopup" />
    </transition>
</template>

<script>
import { computed } from "vue";
import { getData } from "@streampac.io/chef_sp_1";
// @import components
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import UnderConstruction from "@/views/UnderConstruction";

// import LoginPopup from "@/components/LoginPopup";
import ForgotPasswordPopup from "@/components/ForgotPasswordPopup";

import { fetchEnumFlatValues } from "@streampac.io/chef_sp_1";

import themeFunctions from "./functions.js";

export default {
    metaInfo() {
        return {
            title:
                "ANR2023",
            description:
                "",
        };
    },
    data() {
        return {
            isAuthenticated: false,
            savedToken: "",
            getSubscriptions: [],
            getPayPerView: [],
            getMediaIds: [],
            showMobileVersion: false,
        };
    },
    provide: function () {
        return {
            isAuthenticated: computed(() => this.isAuthenticated),
            setAuthenticated: this.setAuthenticated,
            //isMobileVersion: computed(() => this.isMobileScreen())
        };
    },
    created() {
        this.isMobileScreen();
        this.setAuthenticated(getData("loginData") ? true : false);
        this.getOrderData();
        this.saveEnumLookup();
    },
    watch: {
        $route() {
            window.scrollTo(0, 0);
            this.$store.commit("saveBodyBackgroundUrl", false);
        },
    },
    components: {
        Header,
        Footer,
        UnderConstruction,
        // LoginPopup,
        ForgotPasswordPopup,
    },
    computed: {
        currentRouteName() {
            if (this.$route.name) {
                return this.$route.name.toLowerCase();
            } else {
                return false;
            }
        },
    },
    methods: {
        setAuthenticated: function (value) {
            this.isAuthenticated = value;
        },
        isMobileScreen() {
            // const test = () => {
            // }
            // window.addEventListener('resize', () => {
            // 	const windowSize = window.innerWidth;
            // 	if (windowSize <= 1440) {
            // 		this.showMobileVersion = true;
            // 	}
            // 	this.showMobileVersion = false;
            // });
            // const windowSize = window.innerWidth;
            // if (windowSize <= 1440) {
            // 	this.showMobileVersion = true;
            // }
            // return this.showMobileVersion;
        },
        checkLoggedInPages() {
            if (
                this.$route.name !== "Login" &&
                this.$route.name !== "ActivateAccount"
            ) {
                return true;
            }

            return false;
        },
        getOrderData() {
            setTimeout(() => {
                themeFunctions.saveOrderDataInStore(this, this.isAuthenticated);
            }, 200);
        },
        getCookie(cname) {
            let name = cname + "=";
            let ca = document.cookie.split(";");
            for (let i = 0; i < ca.length; i++) {
                let c = ca[i];
                while (c.charAt(0) == " ") {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return "";
        },
        saveEnumLookup() {
            fetchEnumFlatValues(this.isAuthenticated).then((response) => {
                this.$store.commit("saveEnumLookup", response);
            });
        },
        checkFullBodyBgPages() {
            if (this.$route.name == 'Home' && !this.isAuthenticated || this.$route.name == 'ActivateAccount' || this.$route.name == 'ResetPasswordPage') {
                return true;
            }
        }
    },
};
</script>

<style lang="scss">
// @import styles
@import "./assets/css/global.scss";
@import "./assets/css/responsive-global.scss";
</style>
